//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React, { useMemo } from 'react';
import styled from 'styled-components';
//  -- Components ---------------------
import { ArrowLeftOutlined } from '@ant-design/icons';

//  -- Constants ----------------------
import { get } from 'lodash';
//  -- Thunks -------------------------
import { Button, Col, Row } from 'antd';
import SchoolForm from 'features/forms/admin/School';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCurrentOrg } from 'store/organizations/selectors';
import SentryWrap from 'components/Sentry';

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------

const StableWrapperMain = styled.div`
    margin-top:10px;
`;

const AddSchools = ({}) => {
    const location = useLocation();
    const schoolInfo = useMemo(()=>get(location.state, 'school', null),[location.state])
    const currentOrg = useCurrentOrg()
  	const navigate = useNavigate();
 
 
    useEffect(() => {
        async function fetchData() {
      
        }
        fetchData();
    }, [currentOrg]);

 
    const backToDataBrowser = () => {
        navigate('/data-browsers?tab=school');
    };
    return (
        <SentryWrap>
            <Row>
                <Col lg={24}>
                    <Button type="link" primary style={{ paddingLeft: 0, fontSize: 17, marginBottom: 20 }} onClick={backToDataBrowser}>
                        <ArrowLeftOutlined />
                        Back
                    </Button>
                </Col>
            </Row>
            <StableWrapperMain>
                <SchoolForm
                    currentOrg={currentOrg}
                    school={schoolInfo}
                    editing={schoolInfo&&schoolInfo.id}
                    onClose={() => {}}
                />
            </StableWrapperMain>
        </SentryWrap>
    );
};



export default AddSchools;
